import * as eventsApi from "@/api/eventsApi.js"

export const setRsvpData = async (events) => {
  const rsvpableEvents = events.filter((event) => event.rsvpable)

  if (!rsvpableEvents.length) {
    return
  }

  const [{ event_rsvps: rsvpValues }, { event_rsvps: rsvpMeta }] = await eventsApi.rsvpData(rsvpableEvents.map((event) => event.id))

  events.forEach((event) => {
    event.rsvpValue = rsvpValues.find((d) => d.event_id === event.id)?.value
    event.rsvpMeta = rsvpMeta.find((d) => d.event_id === event.id)
  })
}
